/* ==========================================================================
   scuffers-collection.js — B3 collection page (Scuffers 1:1)
   Owns: pill-nav drag scroll, AJAX Load More (+counter/progress), floating
   capsule (sort + subfilter dropdowns), filter drawer (open/apply/clear).
   Hook names are scol-namespaced ([data-scol-*], #scol-*) so the legacy
   collection handlers in theme.js ([data-sort-toggle], [data-filter-apply],
   #filter-drawer) never find matching elements and cannot double-fire.
   ========================================================================== */
(function () {
  'use strict';
  if (window.__scolCollectionInit) return;
  window.__scolCollectionInit = true;

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  ready(function () {
    var grid = document.querySelector('[data-scol-grid]');
    if (!grid) return;

    /* ---------- Pill nav: horizontal drag scroll (cursor grab) ---------- */
    var pillList = document.querySelector('[data-scol-pills]');
    if (pillList) {
      var isDown = false, startX = 0, startScroll = 0, dragged = false;
      pillList.addEventListener('mousedown', function (e) {
        isDown = true;
        dragged = false;
        startX = e.pageX;
        startScroll = pillList.scrollLeft;
      });
      document.addEventListener('mousemove', function (e) {
        if (!isDown) return;
        var walk = e.pageX - startX;
        if (Math.abs(walk) > 4) {
          dragged = true;
          pillList.classList.add('is-dragging');
          pillList.scrollLeft = startScroll - walk;
          e.preventDefault();
        }
      });
      document.addEventListener('mouseup', function () {
        if (!isDown) return;
        isDown = false;
        /* keep pointer-events off until this click finishes so a drag
           doesn't fire the link */
        setTimeout(function () { pillList.classList.remove('is-dragging'); }, 0);
      });
      pillList.addEventListener('click', function (e) {
        if (dragged) { e.preventDefault(); e.stopPropagation(); }
      }, true);
    }

    /* ---------- Load More: AJAX append + counter + progress bar ---------- */
    var loadMoreBtn = document.querySelector('[data-scol-load-more]');
    var rangeEnd = document.getElementById('range-end');
    var totalEl = document.getElementById('total-products');
    var progressBar = document.getElementById('pagination-progress-bar');

    /* total comes off the grid, so the button still knows when to stop even
       when the counter/progress bar are switched off in the section settings */
    var totalProducts = parseInt(grid.getAttribute('data-total') || '', 10);
    if (!totalProducts && totalEl) totalProducts = parseInt(totalEl.textContent, 10);

    function currentShown() {
      return grid.querySelectorAll('.product-block').length;
    }
    function updatePaginationUI() {
      var shown = currentShown();
      var total = totalProducts || shown;
      if (rangeEnd) rangeEnd.textContent = String(shown);
      if (progressBar && total > 0) {
        progressBar.style.width = Math.min(100, (shown / total) * 100).toFixed(2) + '%';
      }
      if (loadMoreBtn && shown >= total) {
        loadMoreBtn.remove(); /* spec: button removed from DOM when all loaded */
        loadMoreBtn = null;
      }
    }

    if (loadMoreBtn) {
      var nextPage = parseInt(grid.getAttribute('data-page') || '1', 10) + 1;
      loadMoreBtn.addEventListener('click', function (e) {
        /* the button is an <a href> so it degrades without JS — swallow the
           navigation here and append in place instead */
        e.preventDefault();
        if (!loadMoreBtn) return;
        loadMoreBtn.classList.add('is-loading');
        var url = new URL(window.location.href);
        url.searchParams.set('page', String(nextPage));
        fetch(url.toString())
          .then(function (res) {
            if (!res.ok) throw new Error('HTTP ' + res.status);
            return res.text();
          })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var newGrid = doc.querySelector('[data-scol-grid]');
            var blocks = newGrid ? newGrid.querySelectorAll('.product-block') : [];
            var frag = document.createDocumentFragment();
            var added = [];
            for (var i = 0; i < blocks.length; i++) {
              var node = document.importNode(blocks[i], true);
              node.classList.add('scol-enter');
              frag.appendChild(node);
              added.push(node);
            }
            grid.appendChild(frag);
            /* entrance: fade/slide in (transition lives in CSS) */
            requestAnimationFrame(function () {
              requestAnimationFrame(function () {
                added.forEach(function (n) { n.classList.remove('scol-enter'); });
              });
            });
            nextPage += 1;
            var nextBtn = doc.querySelector('[data-scol-load-more]');
            var hasNext = !!(newGrid && nextBtn);
            if (loadMoreBtn) {
              loadMoreBtn.classList.remove('is-loading');
              if (!hasNext || blocks.length === 0) {
                loadMoreBtn.remove();
                loadMoreBtn = null;
              } else {
                /* keep the no-JS/middle-click target pointing at the next page */
                loadMoreBtn.setAttribute('href', nextBtn.getAttribute('href'));
              }
            }
            updatePaginationUI();
          })
          .catch(function () {
            /* graceful fallback: plain navigation to the next page */
            var url = new URL(window.location.href);
            url.searchParams.set('page', String(nextPage));
            window.location.href = url.toString();
          });
      });
    }

    /* ---------- Floating capsule: dropdown plumbing ---------- */
    var sortToggle = document.querySelector('[data-scol-sort-toggle]');
    var subToggle = document.querySelector('[data-scol-subfilter-toggle]');
    var sortDropdown = document.getElementById('scol-sort-dropdown');
    var subDropdown = document.getElementById('scol-subfilter-dropdown');
    var sortLabelOpen = null;

    function setSortToggleLabel(open) {
      if (!sortToggle) return;
      if (open) {
        if (sortLabelOpen === null) sortLabelOpen = sortToggle.innerHTML;
        sortToggle.innerHTML =
          '<span>Close filters</span>' +
          '<svg width="10" height="10" viewBox="0 0 10 10" fill="none" aria-hidden="true">' +
          '<path d="M1 1l8 8M9 1L1 9" stroke="currentColor" stroke-width="1"/></svg>';
      } else if (sortLabelOpen !== null) {
        sortToggle.innerHTML = sortLabelOpen;
      }
    }
    function closeDropdowns() {
      if (sortDropdown && !sortDropdown.hidden) {
        sortDropdown.hidden = true;
        setSortToggleLabel(false);
        if (sortToggle) sortToggle.setAttribute('aria-expanded', 'false');
      }
      if (subDropdown && !subDropdown.hidden) {
        subDropdown.hidden = true;
        if (subToggle) subToggle.setAttribute('aria-expanded', 'false');
      }
    }
    function toggleDropdown(dd, toggleBtn, isSort) {
      if (!dd) return;
      var willOpen = dd.hidden;
      closeDropdowns();
      if (willOpen) {
        dd.hidden = false;
        toggleBtn.setAttribute('aria-expanded', 'true');
        if (isSort) setSortToggleLabel(true);
      }
    }
    if (sortToggle) {
      sortToggle.addEventListener('click', function (e) {
        e.stopPropagation();
        toggleDropdown(sortDropdown, sortToggle, true);
      });
    }
    if (subToggle) {
      subToggle.addEventListener('click', function (e) {
        e.stopPropagation();
        toggleDropdown(subDropdown, subToggle, false);
      });
    }
    document.addEventListener('click', function (e) {
      if (sortDropdown && !sortDropdown.hidden && !sortDropdown.contains(e.target)) closeDropdowns();
      else if (subDropdown && !subDropdown.hidden && !subDropdown.contains(e.target)) closeDropdowns();
    });

    /* sort options -> ?sort_by= (page param reset) */
    var currentSort = new URLSearchParams(window.location.search).get('sort_by');
    document.querySelectorAll('[data-scol-sort-option]').forEach(function (opt) {
      if (currentSort && opt.getAttribute('data-scol-sort-option') === currentSort) {
        opt.classList.add('is-active');
      }
      opt.addEventListener('click', function () {
        var params = new URLSearchParams(window.location.search);
        params.set('sort_by', opt.getAttribute('data-scol-sort-option'));
        params.delete('page');
        window.location.href = window.location.pathname + '?' + params.toString();
      });
    });

    /* ---------- Filter drawer ---------- */
    var drawer = document.getElementById('scol-filter-drawer');
    var overlay = document.querySelector('[data-scol-overlay]');

    function openDrawer() {
      closeDropdowns();
      if (drawer) drawer.classList.add('is-open');
      if (overlay) overlay.classList.add('is-open');
      /* spec: body scroll behind stays — no scroll lock */
    }
    function closeDrawer() {
      if (drawer) drawer.classList.remove('is-open');
      if (overlay) overlay.classList.remove('is-open');
    }
    document.querySelectorAll('[data-scol-filter-open]').forEach(function (btn) {
      btn.addEventListener('click', openDrawer);
    });
    document.querySelectorAll('[data-scol-filter-close]').forEach(function (el) {
      el.addEventListener('click', closeDrawer);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (drawer && drawer.classList.contains('is-open')) closeDrawer();
      else closeDropdowns();
    });

    /* drawer "Sort by" group behaves radio-like */
    if (drawer) {
      drawer.querySelectorAll('input[data-scol-drawer-sort]').forEach(function (cb) {
        cb.addEventListener('change', function () {
          if (!cb.checked) return;
          drawer.querySelectorAll('input[data-scol-drawer-sort]').forEach(function (other) {
            if (other !== cb) other.checked = false;
          });
        });
      });
    }

    /* Apply: checked boxes -> Shopify filter params (+ optional sort_by) */
    var applyBtn = document.querySelector('[data-scol-filter-apply]');
    if (applyBtn && drawer) {
      applyBtn.addEventListener('click', function () {
        var params = new URLSearchParams(window.location.search);
        Array.from(params.keys())
          .filter(function (k) { return k.indexOf('filter.') === 0; })
          .forEach(function (k) { params.delete(k); });
        params.delete('sort_by');
        params.delete('page');
        drawer.querySelectorAll('input[type="checkbox"]:checked').forEach(function (cb) {
          if (cb.hasAttribute('data-scol-drawer-sort')) {
            params.set('sort_by', cb.value);
          } else {
            params.append(cb.name, cb.value);
          }
        });
        if (currentSort && !params.has('sort_by')) params.set('sort_by', currentSort);
        var qs = params.toString();
        window.location.href = window.location.pathname + (qs ? '?' + qs : '');
      });
    }

    /* Clear all: drop every filter.* param (keep sort) */
    var clearBtn = document.querySelector('[data-scol-filter-clear]');
    if (clearBtn) {
      clearBtn.addEventListener('click', function (e) {
        e.preventDefault();
        var params = new URLSearchParams(window.location.search);
        Array.from(params.keys())
          .filter(function (k) { return k.indexOf('filter.') === 0; })
          .forEach(function (k) { params.delete(k); });
        params.delete('page');
        var qs = params.toString();
        window.location.href = window.location.pathname + (qs ? '?' + qs : '');
      });
    }
  });
})();
